import { Group } from './group.model';
import { User } from './user.model';

export class Report {
    id : number;
    guid : string;
    reportGuidPbi: string;
    workspaceId: string;
    reportType: string;
    name: string;
    url: string;
    datasetUrl: string;
    datasetId: string;
    createdBy: number;
    createdDate: Date;
    description: string;
    iconFileExtension : string;
    iconBase64: string;
    imageUrl: string;
    safeImage: any;
    requiresIdentity: number;
    asms?: string;
    reportCreator?: User;
    innovationOwner?: User;
    operationsOwner?: User;
    businessOwner?: User;
    reportOwner?: User;

    synced? : boolean;
    tooltip? : string;
    locked? : boolean;

    // Query fields for checking if users exists
    reportOwnerQuery?: string;
    innovationOwnerQuery?: string;
    operationsOwnerQuery?: string;
    businessOwnerQuery?: string;

    countries: any[];
}